import { PartnerProgramBenefitType } from '@pages/partner-program/models/benefit.enum';
import { benefits } from '@pages/partner-program/models/benefits';
import { PartnerProgramBenefit } from '@pages/partner-program/models/benefit.interface';

export const tierBenefits: PartnerProgramBenefit[] = [
  benefits[PartnerProgramBenefitType.DedicatedAccountManager],
  benefits[PartnerProgramBenefitType.KaseyaMSPSuccessTeam],
  benefits[PartnerProgramBenefitType.MSPSuccessJumpstart],
  benefits[PartnerProgramBenefitType.FuelingYourSuccessKaseyaAppreciationLunch],
  benefits[PartnerProgramBenefitType.RITSMRemoteITSecurityManagementProgram],
  benefits[PartnerProgramBenefitType.AccessToKaseyaUniversity],
  benefits[PartnerProgramBenefitType.FreeProductTraining],
  benefits[PartnerProgramBenefitType.FullTimeSupport],
  benefits[PartnerProgramBenefitType.AccessToTechnicalAccountManagementTeam],
  benefits[PartnerProgramBenefitType.MAContent],
  benefits[PartnerProgramBenefitType.AccessToKaseyaConnectLocalEvents],
  benefits[PartnerProgramBenefitType.PartnerCommunityForum],
  benefits[PartnerProgramBenefitType.NFRDiscountProgram],
  benefits[PartnerProgramBenefitType.AccessToKaseyaCenterEventsWithAnEBCVisitInMiami],
  benefits[PartnerProgramBenefitType.MarketingDevelopmentFundsMDF],
  benefits[PartnerProgramBenefitType.AccessToFreePassesToIndustryEvents],
  benefits[PartnerProgramBenefitType.AdditionalKaseyaConnectTicketsAvailableAtADiscount],
  benefits[PartnerProgramBenefitType.OneFreeTicketToKaseyaConnect],
  benefits[PartnerProgramBenefitType.OneFreeTicketToKaseyaConnectEuropeOrAPAC],
  benefits[PartnerProgramBenefitType.VIPRegistrationAtKaseyaConferences],
  benefits[PartnerProgramBenefitType.AccessToTheBlueDiamondReceptionAtGlobalEvents],
  benefits[PartnerProgramBenefitType.SpecialAccessToExecutivesAtEvents],
  benefits[PartnerProgramBenefitType.EliteSupport],
  benefits[PartnerProgramBenefitType.QuarterlyGivebackDays],
];
